export default __webpack_public_path__ + "static/media/element_24.d9df4c96.avif";